var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-empty',{staticClass:"custom-image",attrs:{"image":require('@/assets/result-empty.png'),"description":_vm.tag == true
        ? '您在近三天内没有参与答题，赶快来参与吧～'
        : '您还没有参与答题，赶快来参与吧～'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }